<div class="snackbar">
    <div class="snackbar-content">
        <span *ngIf="data?.isInfo; else isSuccessBlock">
            <img  class="img-size" src="./assets/icons/icon_info_fill.svg" alt="info-icon">
        </span>
        <ng-template #isSuccessBlock>
            <span *ngIf="data?.isSuccess">
                <img class="img-size" src="./assets/icons/icon_success.svg" alt="tick-success-icon">
            </span>
            <span *ngIf="!data?.isSuccess">
                <img class="img-size" src="./assets/icons/failure.svg" alt="failure-close-icon">
            </span>
        </ng-template>
        <div class="text">
            <span class="heading" [ngClass]="{ 'add-contact': fromAddContact }">{{data?.heading| translate}}</span>
            <span class="sub-heading">{{data?.subHeading| translate}}</span>
        </div>
    </div>
    <span class="close" [ngClass]="{ 'close-button': fromAddContact }" *ngIf="data?.showCloseButton" (click)="data.close()">
        <img *ngIf="!fromAddContact" src="./assets/icons/close_white.svg" alt="white-close-icon">
        <img *ngIf="fromAddContact" src="./assets/icons/close.svg" alt="close-icon">
    </span>
</div>
